module.exports = __webpack_public_path__ + "img/garden.9ae50139.png";